import React from 'react';
import cx from 'classnames';
import s from './style';

function Filter({ className, onClick, name, text, filter, isBlocked }) {
  const classes = cx(s.root, className, {
    [s.blocked]: isBlocked,
    [s.active]: filter === name
  });
  return (
    <div className={classes} onClick={() => !isBlocked && onClick(name)}>
      {text}
    </div>
  );
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Filters/Filter/Filter.js